import React from "react";

import * as styles from "./PanelSection.module.scss";
import { ValidatedPanelSection } from "../utils";
import { match } from "ts-pattern";
import PromoLinks from "./links/PromoLinks";
import DestinationLinks from "./links/DestinationLinks";
import ShipLinks from "./links/ShipLinks";
import GenericLinks from "./links/GenericLinks";
import CruisesLaunchesLinks from "./links/CruisesLaunchesLinks";
import { useMenuContent } from "../MenuContentProvider";

type Props = ValidatedPanelSection;

const PanelSection: React.FC<Props> = ({
  showItemsMedia,
  items,
  showTitle,
  title,
  collection,
  layout = "auto"
}) => {
  const { destinations, ships, cruisesLaunches } = useMenuContent();

  const links = match(collection)
    .with("destinations", () => (
      <DestinationLinks
        destinations={destinations}
        showItemsMedia={showItemsMedia}
      />
    ))
    .with("ships-expeditions", () => (
      <ShipLinks
        shipType="Expedition"
        ships={ships}
        showItemsMedia={showItemsMedia}
      />
    ))
    .with("ships-ocean", () => (
      <ShipLinks
        shipType="Classic"
        ships={ships}
        showItemsMedia={showItemsMedia}
      />
    ))
    .with("promos", () => <PromoLinks />)
    .with("cruises-launches", () => (
      <CruisesLaunchesLinks cruisesLaunches={cruisesLaunches} />
    ))
    .otherwise(() => (
      <GenericLinks items={items} showItemsMedia={showItemsMedia} />
    ));

  const groupsStyles = {
    "--group-columns": match(layout)
      .with("1column", () => 1)
      .with("2columns", () => 2)
      .with("3columns", () => 3)
      .with("4columns", () => 4)
      .otherwise(() => 1)
  } as React.CSSProperties;

  return (
    <li role="none" className={styles.group} style={groupsStyles}>
      {showTitle && <div className={styles.title}>{title?.localized}</div>}

      <ul className={styles.links}>{links}</ul>
    </li>
  );
};

export default PanelSection;
